import { ReactElement,  useEffect,  useRef, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { UniversalListStyle as classes } from "./style";
import { ItemSummary } from "./ItemSummary";
import NotificationMessage from "../NotificationMessage/NotificationMessage";
import ListItemIcon from "@mui/material/ListItemIcon";
import FormControlLabel from "@mui/material/FormControlLabel";
import {  BiInfinite, BiTrash } from "react-icons/bi";
import Checkbox from "@mui/material/Checkbox";
import FdButton from "../UIComponents/Button/FdButton";
import { actionDialogType } from "../../components";
import { FiLogOut } from "react-icons/fi";
import { theme } from "../../theme";
import Tooltip from "@mui/material/Tooltip";
import { ICheckInAttendeeList } from "../../dataProvider/interfaces/IAttendee";
import Typography from "@mui/material/Typography";

export enum dataType {
  ALERT = "ALERT",
  CHECKED_IN_ATTENDEE = "CHECKED_IN_ATTENDEE",
}
export interface IProps {
  onItemCheck?: Function;
  onItemClick?: Function;
  onEdit: Function;
  onDelete?: Function;
  list: any[];
  setUpdate?: Function;
  onCheckOut?: Function;
  bulkActions?: any;
  customActions?: any;
  type?: dataType | any;
  hasCheckBox?: boolean;
  className?: string;
  selectedIndex?: string;
  noDataContent?: React.ReactNode;
}

/** Generic list component */

const UniversalList = ({
  list,
  bulkActions,
  customActions,
  type,
  hasCheckBox,
  onEdit,
  onDelete,
  onCheckOut,
  onItemClick,
  className,
  selectedIndex,
  noDataContent,
}: IProps) => {
  const notificationRef = useRef<any>();
  const [selected, setSelected] = useState(false);
  const [universalList, setUniversalList] = useState<any[]>([]);
  const [actionDialog, setActionDialog] = useState<any>({
    open: true,
    title: "",
    icon: <BiTrash size="45" />,
    type: actionDialogType.WARNING,
    onCancel: () => {},
    onClose: () => {},
    onConfirm: () => {},
  });
  const [stats, setStats] = useState<any>({
    overLimit: {},
    noAccess: {},
    withAccess: {},
  });

  const hideWarningDialog = () => {
    const newActionDialog = { ...actionDialog, open: false };
    setActionDialog(newActionDialog);
  };
  const showWarningDialog = (
    message: string,
    confirmCallback: Function,
    icon?: ReactElement
  ) => {
    const newActionDialog = {
      ...actionDialog,
      open: true,
      ...(icon && { icon: icon }),
      onCancel: () => {
        hideWarningDialog();
      },
      onClose: () => {
        hideWarningDialog();
      },
      onConfirm: () => {
        hideWarningDialog();
        confirmCallback();
      },
      title: message,
    };
    setActionDialog(newActionDialog);
  };

  const getListItemTitle = (item: any) => {
    let title = "";
    if (type === dataType.CHECKED_IN_ATTENDEE) {
      title = stats.overLimit[item.id]
        ? "Consumed more than allowed no. of scans."
        : (stats.noAccess[item.id] ? "Does not have a reservation for this session" : "");
    }
    return title;
  };

  const getHightLightItemCss = (item:any) =>{
    const className = stats.overLimit[item.id] ?  "hightLightItemOrange" : (stats.noAccess[item.id] ? "hightLightItemRed" : "");
    return type === dataType.CHECKED_IN_ATTENDEE ? className : '';
  }

  const processCheckedInAttendees = (attendees: ICheckInAttendeeList[]) => {
    const overLimit: ICheckInAttendeeList[] =[];
    const noAccess: ICheckInAttendeeList[] =[];
    const withAccess: ICheckInAttendeeList[] =[];
    attendees.map((item: any) => {
      if (item.accessAmount < 0) {
        stats.withAccess[item.id] = true;
        withAccess.push(item);
      } else if (item.consumedAmount > item.accessAmount) {
        if (item.accessAmount === 0) {
          stats.noAccess[item.id] = true;
          noAccess.push(item);
        } else {
          stats.overLimit[item.id] = true;
          overLimit.push(item);
        }
      }else{
        stats.withAccess[item.id] = true;
        withAccess.push(item);
      }
    });
    setStats(stats);
    const sortedCheckIn = [...noAccess,...overLimit,...withAccess];
    setUniversalList(sortedCheckIn);
  };

  useEffect(() => {
    if (type === dataType.CHECKED_IN_ATTENDEE) {
      processCheckedInAttendees(list);
    } else {
      setUniversalList(list);
    }
  }, [list]);

  return (
    <>
    <Box
      sx={classes.wrapper}
      className={className}
      aria-label={`${type}-wrapper`}
    >
      {/* <BulkAction /> */}
      {(bulkActions || customActions) && universalList?.length > 0 && (
        <Box sx={classes.bulkActions}>
          {/* left bulk action buttons */}
          <Box flexGrow={1} textAlign="left">
            {bulkActions?.map((action: any) => (
              <FdButton
                key={action.key}
                sx={[
                  classes.bulkActionButton,
                  classes.actionButton,
                  // isActiveBulkAction(action)
                  //   ? { color: theme.palette.primary.main }
                  //   : {},
                ]}
                startIcon={action.startIcon}
                variant="text"
                ButtonName={action.label}
              />
            ))}
          </Box>
          {/* right custom action buttons */}
          <Box>
            {customActions &&
              customActions.map((action: any) => (
                <FdButton
                  key={action.key}
                  // color="primary"
                  sx={[
                    classes.customActionButton,
                    classes.actionButton,
                    // {
                    //   color: !showFullSession
                    //     ? `${theme.palette.text.primary}`
                    //     : `${theme.palette.primary.main}`,
                    //   cursor: !showFullSession ? "default" : "pointer",
                    //   marginRight: !showFullSession ? 3 : 0,
                    // },
                  ]}
                  startIcon={action.startIcon}
                  variant="text"
                  onClick={() => {
                    if (action.key === "checkOutAll") {
                      showWarningDialog(
                        "Are you sure you want to checkout attendees?",
                        action.callback(),
                        <FiLogOut size="45" />
                      );
                    }
                  }}
                >
                  {action.label}
                </FdButton>
              ))}
          </Box>

          {/** Show the number of selected items */}
          {/* <Typography
                component="span"
                style={{ color: "#fff", fontSize: "18px" }}
                align="left"
              >
                {checkedItems.length} selected{" "}
                {`item${checkedItems.length > 1 ? "s" : ""}`}
              </Typography> */}
        </Box>
      )}
      <Box
        sx={[
          classes.listWrapper,
          {
            height:
              (bulkActions || customActions) && universalList?.length > 0
                ? "calc(100% - 55px)"
                : "100%",
          },
        ]}
      >
      {universalList?.length === 0 ? noDataContent : 
        <List sx={classes.listRoot}>
       
         {universalList?.map((item, index) => {
          const hightLightAttendee = getHightLightItemCss(item);
          return (
            <Tooltip key={index} title={getListItemTitle(item)} placement="top">
              <ListItem
                key={index}
                sx={{
                  ...classes.listItem,
                  background:
                    index % 2 === 0 ? "#fff" : theme.palette.grey[600],
                }}
                className={`fdListItem ${hightLightAttendee}`}
                selected={type === dataType.ALERT && selectedIndex === item.id}
                onClick={() => {
                  onEdit && onEdit(item?.id);
                  onItemClick && onItemClick(item?.id);
                }}
              >
                {hasCheckBox && (
                  <ListItemIcon
                    sx={classes.checkboxIcon}
                    className="checkboxIcon"
                  >
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      checked={selected ? true : false}
                      onChange={() => setSelected(!selected)}
                    />
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                    <Box sx={{flex:1}}>  
                      <ItemSummary
                        item={item}
                        type={type}
                        actions={{
                          onDelete: onDelete,
                          onEdit: onEdit,
                          onCheckOut: onCheckOut,
                          onDuplicate: undefined,
                          setDefault: undefined,
                        }}
                      />
                      </Box>
                      {type === dataType.CHECKED_IN_ATTENDEE && (
                        <Typography
                          variant="body2"
                          sx={{ whiteSpace: "nowrap", marginLeft: 2, display: "flex" }}
                        >
                          <Box>Consumed: {item.consumedAmount}/</Box>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {item.accessAmount == -1 ? (
                              <BiInfinite size="12" style={{}} />
                            ) : (
                              item.accessAmount
                            )}
                          </Box>
                        </Typography>
                      )}
                    </Box>
                  }
                />
              </ListItem>
            </Tooltip>
          );
        })}
       </List>
       }
    </Box>
  </Box>
       <NotificationMessage ref={notificationRef} />
      </>
  );
};

export default UniversalList;